import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Navbar } from '@/components/organisms/Navbar';
import { SideBar } from '@/components/organisms/SideBar';

type Props = {
  children?: React.ReactNode | React.ReactNode[];
};

type RouteConfig = {
  route: string;
  strict: boolean;
};
const HIDE_SIDEBAR_ROUTES: RouteConfig[] = [
  { route: '/', strict: true },
  { route: '/proposal-restaurant', strict: false },
  { route: '/ad-infos', strict: true },
  { route: '/restaurant/inactive', strict: true },
  { route: '/moderation', strict: false },
  { route: '/claim', strict: false }
];

const shouldHideSidebar = (pathname: string, routes: RouteConfig[]): boolean => {
  return routes.some(({ route, strict }) => (strict ? pathname === route : pathname.startsWith(route)));
};

export const DashboardLayout = ({ children }: Props): JSX.Element => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const hideSidebar = shouldHideSidebar(location.pathname, HIDE_SIDEBAR_ROUTES);

  // Close sidebar when location changes
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const handleOnMenuClick = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex flex-col h-screen w-screen">
      <div>
        <Navbar onMenuClick={handleOnMenuClick} hideSidebar={hideSidebar} />
      </div>
      <div className="flex flex-row md:overflow-auto">
        {!hideSidebar && <SideBar sidebarOpen={sidebarOpen} onChangeSidebar={(value) => setSidebarOpen(value)} />}

        <main className={clsx(`flex flex-col space-y-5 flex-auto md:overflow-y`, !hideSidebar ? 'md:pl-60 xl:pl-80 mx-5 md:mx-14 mb-14' : 'mx-auto')}>
          {children}
        </main>
      </div>
    </div>
  );
};
